'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'investorCountry', 'InvestorCountryService', 'StatusService',
    function ($scope, $modalInstance, investorCountry, InvestorCountryService, StatusService) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.checkUniqueName = checkUniqueName;

        init();

        // region Function

        function init() {
            $scope.uniqueName = true;
            $scope.investorCountry = angular.copy(investorCountry);

            if (investorCountry == null || angular.equals({}, investorCountry) || investorCountry.id == null) {
                $scope.title = "Создание нового происхождения инвесторов";
            } else {
                $scope.title = "Редактирование происхождения инвесторов \"" + $scope.investorCountry.name + "\"";
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.investorCountry.status) {
                    $scope.investorCountry.status = data._embedded;
                }
            });
        }

        function ok() {
            $modalInstance.close($scope.investorCountry);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function checkUniqueName(name) {
            if (name != null && name.trim() != "") {
                InvestorCountryService.api.isUniqueName({name: name}, {id: $scope.investorCountry.id}, (data) => {
                    $scope.uniqueName = data._embedded;
                });
            } else {
                $scope.uniqueLogin = true;
            }
        }

        // endregion

    }];